import { render, staticRenderFns } from "./browser-form.vue?vue&type=template&id=f7fe5020"
import script from "./browser-form.vue?vue&type=script&lang=js"
export * from "./browser-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports